export const getQuoteQuestions = (quote: string): string[] => {
  return [
    `Analyze <color>${quote}</color>'s financials`,
    `Analyze <color>${quote}</color>'s market performance`,
    `What is <color>${quote}</color>'s 200-day MA?`,
    `Compare <color>${quote}</color> performance to the market?`,
    `How has <color>${quote}</color>'s EPS changed?`,
    `How is <color>${quote}</color>'s EBITDA trending?`,
    `How is <color>${quote}</color>'s EV/EBITDA ratio?`,
    `How is <color>${quote}</color>'s operating margin?`,
    `How is <color>${quote}</color>'s price-to-book ratio?`,
    `How is <color>${quote}</color>'s revenue growing?`,
    `How is <color>${quote}</color>'s ROE trending?`,
    `How is the earnings season affecting <color>${quote}</color>?`,
    `Show <color>${quote}</color>'s technical analysis`,
    `What are <color>${quote}</color>'s Bollinger Band values?`,
    `What are analysts' targets for <color>${quote}</color>?`,
    `What do <color>${quote}</color>'s technical indicators suggest?`,
    `What does <color>${quote}</color>'s DCF valuation show?`,
    `What is <color>${quote}</color>'s 5 years max drawdown?`,
    `What is <color>${quote}</color>'s 7 days volume trend?`,
    `What is <color>${quote}</color>'s all-time high price?`,
    `What is <color>${quote}</color>'s all-time low price?`,
    `What is <color>${quote}</color>'s average daily volume?`,
    `What is <color>${quote}</color>'s current market cap?`,
    `What is <color>${quote}</color>'s current price trend?`,
    `What is <color>${quote}</color>'s current ratio?`,
    `What is <color>${quote}</color>'s debt-to-equity ratio?`,
    `What is <color>${quote}</color>'s dividend yield?`,
    `What is <color>${quote}</color>'s drawdown from recent high?`,
    `What is <color>${quote}</color>'s free cash flow?`,
    `What is <color>${quote}</color>'s gross margin?`,
    `What is <color>${quote}</color>'s max drawdown this year?`,
    `What is <color>${quote}</color>'s net income trend?`,
    `What is <color>${quote}</color>'s operating cash flow?`,
    `What is <color>${quote}</color>'s P/E ratio?`,
    `What is <color>${quote}</color>'s P/S ratio?`,
    `What is <color>${quote}</color>'s ROA?`,
    `What is <color>${quote}</color>'s Sharpe ratio?`,
    `What is the consensus rating for <color>${quote}</color>?`,
    `What is the Pivot resistance level for <color>${quote}</color>?`,
    `What is the Pivot support level for <color>${quote}</color>?`,
    `What’s driving <color>${quote}</color>'s recent performance?`,
    `What’s the latest news on <color>${quote}</color>?`,
  ];
};

export const getCRYPTOQuestions = (crypto: string): string[] => {
  return [
    `Analyze <color>${crypto}</color>'s market performance`,
    `What is <color>${crypto}</color>'s 200-day MA?`,
    `Is <color>${crypto}</color>'s daily volume above average?`,
    `Show <color>${crypto}</color>'s technical analysis`,
    `What are <color>${crypto}</color>'s Bollinger Band values?`,
    `What is <color>${crypto}</color>'s 5 years max drawdown?`,
    `What is <color>${crypto}</color>'s all-time high price?`,
    `What is <color>${crypto}</color>'s average daily volume?`,
    `What is the Pivot resistance level for <color>${crypto}</color>?`,
    `What is the Pivot support level for <color>${crypto}</color>?`,
  ];
};

export const getRandomQuestions = (questions: string[], numberOfQuestions: number): string[] => {
  const randomIndexes = new Array(numberOfQuestions).fill(0).map(() => Math.floor(Math.random() * questions.length));

  return questions.filter((_item, index) => randomIndexes.includes(index));
};
